<template>
  <div class="introduction">
    <!-- <div class="introduction-banner">
      <img src="@/assets/twoStar/3.jpg" alt />
    </div> -->
    <div class="introduction-content">
      <div class="introduction-content-title">东坡水街商圈联盟工作简介</div>
      <p>
        眉山东坡水街建于2019年，全长1.8公里，毗邻东坡湿地公园，由东坡印象、穿越盛世、东坡里三部分组成。水街商圈联盟成立于2021年，以“党建联盟”为突破口，搭建共治平台，链接共治资源，推动社区、物业、商家共建共享、共驻共赢。
      </p>
      <p>
        <span>一个平台促治理。</span>坚持需求导向，商圈党委搭建商管物业、街道社区、职能部门、商家代表等多方共建一个议事协商平台，建立商圈资源、需求、服务、党建4张清单，以联盟力量定期研判解决人群拥堵、停车困难、游商泛滥等问题。
      </p>
      <p>
        <span>多方参与优服务。</span>坚持资源整合，商圈联盟整合商管物管、社区社工、团委志愿、救援协会、应急消防等多方力量，牵头组建“多功能”志愿者队伍，常态化在节假日、人流高峰时段开展交通疏导、安全隐患排查、游客咨询服务等活动。商圈联盟优势资源组织开展亲子、趣缘、文旅营销培训等主题活动，提升商户竞争力。联合三条水街商管公司畅通商户筛选、退出机制，与商户签订商户公约，提升水街商圈品质和市场竞争力。
      </p>
      <p>
        <span>党建引领助发展。</span>坚持党建赋能，商圈联盟创设“网红水街映党红”主题活动，订制“众人合力推红船”、“百年征程一起走”体感互动游戏，定期组织《党啊！我的母亲》《遇见东坡》等6部红色作品融入商圈商演，持续浓厚商圈党史学习教育氛围，让“红色党建”点亮“网红水街”。
      </p>
      <!-- <img src="@/assets/twoStar/dpCommerceIntro.png" alt=""> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.introduction {
  &-content {
    p {
      text-indent: 0.4rem;
      color: #333333;
      margin-bottom: 0.2rem;
    }
    span {
        font-weight: 600;
    }
    &-title {
      font-weight: bold;
      font-size: 0.36rem;
      text-align: center;
      line-height: 3;
    }
    img {
      max-width: 100%;
    }
    position: absolute;
    // top: 2.5rem;
    width: 94%;
    left: 3%;
    box-shadow: 0px 0.08rem 0.24rem 0px rgba(0, 0, 0, 0.17);
    border-radius: 0.08rem;
    padding: 0.2rem;
    padding-bottom: .5rem;
  }
  &-banner {
    img {
      width: 100%;
    }
  }
  padding: 1rem 0.2rem 0;
  font-size: 0.3rem;
  background: #fff;
}
</style>